//medidad Banner 650x360px
export const ultimasNoticias = [
   {
        "imagen" :"../assets/imgs/Convocatorias/2026/Transparencia en Corto 2026.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/contraloriat/dir1/Documentos/TRANSP%20EN%20CORTO_CONVOCATORIA_2026.pdf",
        "titulo" : "XXI edición del Concurso Nacional de Transparencia en Corto ",
        "fecha" : "del 05 de junio al 21 de agosto del 2026"
    },
      {
        "imagen" :"../assets/imgs/Convocatorias/2026/Convocatoria Alumnos.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/11.-CONVOCATORIA ALUMNADO.pdf",
        "titulo" : "IX Festival y Curso de Perfeccionamiento para Orquestas Sinfónicas Juveniles Musicampus 2026",
        "fecha" : "del 02 de junio al 30 de junio del 2026"
    },
      {
        "imagen" :"../assets/imgs/Convocatorias/2026/Convocatoria Talleristas.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/12.-CONVOCATORIA TALLERISTAS.pdf",
        "titulo" : "IX Festival y Curso de Perfeccionamiento para Orquestas Sinfónicas Juveniles Musicampus 2026",
        "fecha" : "del 02 de junio al 11 de junio del 2026"
    },
   {
        "imagen" :"../assets/imgs/Convocatorias/2026/Resultados de la convocatoria Celeblando la Danza en los CCRs.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/Resultados Danza en los CCRs.jpeg",
        "titulo" : "Resultados de la convocatoria Celeblando la Danza en los Centros Culturales Regionales",
        "fecha" : ""
    },
   {
        "imagen" :"../assets/imgs/Convocatorias/2026/encuentro estatal.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/Resultados Encuentro estatal.jpeg",
        "titulo" : "Resultados de la convocatoria Encuentro Estatal de la Danza Contemporanea",
        "fecha" : ""
    },
  {
        "imagen" :"../assets/imgs/Convocatorias/2026/Resultados Celebrando la Danza en Hidalgo.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/Resultados danza .jpeg",
        "titulo" : "Resultados de la convocatoria Celebrando la Danza en Hidalgo",
        "fecha" : ""
    },
   ]